<template>
    <div >
      <b-row>
          <b-col md="12">
            <MdTitle v-bind:Text="$t('DetailPrescribedDrugsDiagnosisRep.ReportTitle')" />
          </b-col>
      </b-row>
      <b-row>
          <div class="col-sm-12 col-md-12 mb-4">
              <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                  <div class="input-group"  dir="ltr">
                      <input type="text" class="form-control" v-model="parameter.SearchCriteria"
                          @keyup.enter="LoadDetailPrescribedDrugs" />

                      <div class="input-group-append">
                          <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                              v-bind:IconClass="'mdi mdi-magnify'" v-on:click="LoadDetailPrescribedDrugs">
                          </MdButton>
                      </div>
                  </div>
              </div>
          </div>
      </b-row>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'DetailPrescribedDrugsDiagnosisRepDateFrom'"
              :Type="'date'"  
              :OnPressEnter="LoadDetailPrescribedDrugs"            
              :isRequired="false"                           
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateFromValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'DetailPrescribedDrugsDiagnosisRepDateTo'"
              :OnPressEnter="LoadDetailPrescribedDrugs"    
              :Type="'date'"             
              :isRequired="false"                           
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateToValid">
          </MdDateTime>

          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdLookupMultiSelect
                v-bind:Label="$tc('Shared.Patient',2)"
                v-bind:ModelCode="PatientCodeModel"
                v-bind:RefCode="'patientcode'"
                v-bind:Api="'Patients'"
                v-bind:FieldCode="'patientcode'"
                v-bind:FieldDescription="'firstname'"
                :SearchTitle="$tc('Shared.Patient',2)"
                :GetValues="getValues"
                :InvalidFeedback="$t('Msg.InvalidCode')"
                :SearchFieldCode="'PatientCode'"
                :AuxFields="AuxFields"
                :FieldsDate="fieldsDate"
                :ServerSidePagination="true"
                v-bind:Fields="BaseFields"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdLookupMultiSelect
                v-bind:Label="$t('Medication.Drugs')"
                v-bind:ModelCode=DrugsCodeModel
                v-bind:RefCode="'DrugsCode'"
                v-bind:Api="'Drugs'"
                v-bind:FieldCode="'drugCode'"
                v-bind:FieldDescription="'drugname'"
                :SearchTitle="$t('Medication.Drugs')"
                :GetValues="getValuesDrugs"
                :InvalidFeedback="$t('Msg.InvalidCode')"
                :SearchFieldCode="'Code'"
                :AuxFields="AuxFieldsDrugs"
                :ServerSidePagination="true"
                v-bind:Fields="BaseFieldsDrugs"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.DrugType')"
              v-bind:Options="DrugTypeList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"
              v-bind:Model="DrugTypeModel"  
              :Input="ChangeDrugType"
              :SortAlphabetical="true"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Status')"
              v-bind:Options="StatusOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:AllowEmpty="true"
              v-bind:Multiple="true"
              v-bind:Model="StatusModel"
              :Input="ChangeStatus"
              :SortAlphabetical="true"
              :UseTitleCase="true"/>
          </b-col>
          <b-col lg="3" md="3" sm="12" v-if="validateInternalPrescriptions">
            <MdSelect
              v-bind:Label="$t('Shared.AutoValidatedStatus')"
              v-bind:Options="AutoValidatedStatusOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:AllowEmpty="true"
              v-bind:Model="AutoValidatedStatusModel"
              :Input="ChangeAutoValidatedStatus"
              :SortAlphabetical="true"
              :UseTitleCase="true"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.AdmissionType')"
              v-bind:Options="admissionType"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:Model="admiType"
              :Input="ChangeAdmiType"
              :SortAlphabetical="true"
              :UseTitleCase="true"
            />
          </b-col>
        </b-row>
        <b-row>
        <b-col lg="12" md="12" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadDetailPrescribedDrugs"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
               
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('DetailPrescribedDrugsDiagnosisRep.ReportTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportDetailPrescribedDrugDFilters"
          :ReportName="'DetailPrescribedDrugsD'"
          :ReportTitle="$t('DetailPrescribedDrugsDiagnosisRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('DetailPrescribedDrugsDiagnosisRep.ReportTitle')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/DetailPrescribedDrugsD/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js'
  import UtilsService from '@/services/utils.service'
  import Utils from "@/common/utils";
  import { EventBus } from '@/event-bus.js';
  import PharmacyOptionService from '@/services/pharmacyoption.service'
  
  export default Vue.extend({
      name: "DetailPrescribedDrugsDiagnosisRep",
      mixins: [ ShowMessage, DBFunctions, PharmacyRepFunctions ],
      components: { DxPopup },
      data() {
          return {
              isParamVisible: true,
              isReportVisible: false,
              dateFrom: null,
              dateTo: null,
              reportParams: [],
              DrugList:[],
              PatientsList: [],
              PatientCodeModel: [],
              DrugsCodeModel: [],
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0       
              },
              params: {
                DrugList: '',
                PatientCode: '',
                DrugType: '',
                Status: '',
                AutoValidatedStatus: ''
              },
              DrugTypeModel: '',
              DrugTypeList: [],
              StatusModel: '',
              StatusOptions: [
                {"value":"ORDERED","name":this.$t('Shared.ORDERED')},
                {"value":"PENDING","name":this.$t('Shared.PENDING')},
                {"value":"FILLED","name":this.$t('Shared.FILLED')},
                {"value":"FULLYGIVEN","name":this.$t('Shared.FULLY GIVEN')},
                {"value":"PARTIALLYGIVEN","name":this.$t('Shared.PARTIALLY GIVEN')},
                {"value":"MARSCREATED","name":this.$t('Shared.MARSCREATED')},
                {"value":"RECEIVED","name":this.$t('Shared.Received')},
                {"value":"VOIDED","name":this.$t('Shared.VOIDED')},
                {"value":"INACTIVE","name":this.$t('Shared.Inactive')},
                {"value":"PARTIALLYFILLED","name":this.$t('Shared.PARTIALLY FILLED')},
                {"value":"UNABLETOFILL","name":this.$t('Shared.UNABLE TO FILL')},
                {"value":"VALIDATED","name":this.$t('Shared.VALIDATED')},
              ],
              validateInternalPrescriptions: false,
              AutoValidatedStatusModel: '',
              AutoValidatedStatusOptions: [
                { value: 'PENDING', name: this.$t('Shared.PENDING') },
                { value: 'VALIDATED', name: this.$t('Shared.VALIDATED') },
              ],
              admissionType: [
                { value: 'Inpatient', text: this.$t('Shared.Inpatient') },
                { value: 'Outpatient', text: this.$t('Shared.Outpatient') },
              ],
              admiType: '',
              orderOptions: [
                { value: 0, text: this.$t('Shared.Date') },
                { value: 1, text: this.$t('Shared.PatientName') },
                { value: 2, text: this.$t('Shared.DrugName') }
              ],
              order: 0,
              items: [],         
              fields: [
                // { key: 'RecordID', sortable: true, label: this.$t('Shared.RecordID'), class: 'text-left' },
                { key: 'PatientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-left' },
                { key: 'PatientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-left' },
                { key: 'AdmType', sortable: true, label: this.$t('Shared.AdmissionType'), class: 'text-left' },
                { key: 'DrugCode', sortable: true, label: this.$t('Shared.DrugCode'), class: 'text-left' },
                { key: 'DrugName', sortable: true, label: this.$t('Shared.DrugName'), class: 'text-left' },
                { key: 'Quantity', sortable: true, label: this.$t('Shared.quantity'), class: 'text-center' },
                { key: 'IssuedDate', sortable: true, label: this.$t('Shared.IssuedDate'), class: 'text-center' },
                { key: 'Usage', sortable: true, label: this.$t('Shared.Usage'), class: 'text-left' },
                { key: 'Mode', sortable: true, label: this.$t('Shared.Mode'), class: 'text-left' },
                { key: 'InternalStatus', sortable: true, label: this.$t('Shared.Status'), class: 'text-left' },
                { key: 'AutoValidateStatus', sortable: true, label: Utils.strToTitleCase(this.$t('Shared.AUTO VALIDATED')), class: 'text-left' },
                { key: 'DiagName', sortable: true, label: this.$t('DetailPrescribedDrugsDiagnosisRep.DiagName'), class: 'text-left' },
                { key: 'Prescriber', sortable: true, label: this.$t('Shared.Prescriber'), class: 'text-left' },
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:['IssuedDate'],
              isDateFromValid: true,
              isDateToValid: true,
              AuxFields:['lastname'],
              AuxFieldsDrugs:['status'],
              fieldsDate:['dob'],
              BaseFields:[
                  { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
                  { key: 'lastname', sortable: true, label: this.$t('Shared.LastName')},
                  { key: 'patientcode', sortable: true, label: this.$t('Shared.Code')},
                  { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone')},
                  { key: 'address1', sortable: true, label: this.$t('Shared.Address1')},
                  { key: 'city', sortable: true, label: this.$t('Shared.City')},
                  { key: 'state', sortable: true, label: this.$t('Shared.State')},
                  { key: 'country', sortable: true, label: this.$t('Shared.Country')},
                  { key: 'zip', sortable: true, label: this.$t('Shared.Zip')}
              ],
              BaseFieldsDrugs:[
                  { key: 'drugname', sortable: true, label: this.$t('Shared.DrugName')},
                  { key: 'activeingred', sortable: true, label: this.$t('Shared.activeIngredients')},
                  { key: 'dosage', sortable: true, label: this.$t('Shared.Dosage')},
                  { key: 'form', sortable: true, label: this.$t('Shared.Form')},
                  { key: 'drugCode', sortable: true, label: this.$t('Shared.DrugCode') },
              ],  
          }
      },
      methods: {

          getValues: function (value) {
              this.PatientCodeModel = value
              this.params.PatientCode = value.join(',')
          },

          getValuesDrugs: function (value) {
              this.DrugsCodeModel = value
              this.params.DrugList = value.join(',')
          },

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },

          ChangeStatus(values) {
            var status = '';
            if (values && values.length > 0) {
                status = values.map(x => x.value).join(',');
            }
            this.params.Status = status; 
          },

          ChangeDropDownPatients(values) {
            var pCode = '';
            if (values && values.length > 0) {
                pCode = values.map(x => x.patientcode).join(',');
            }
           this.params.PatientCode = pCode; 
          },

          customLabelPatients ({ PatientName, patientcode }) {
            return `${PatientName} – ${patientcode}`
          },

          ChangeAdmiType(value) {
            this.admiType = value ? value.value : '';
          },

          ChangeAutoValidatedStatus(value) {
            this.AutoValidatedStatusModel = value;
            this.params.AutoValidatedStatus = value ? value.value : '';
          },

          onClickClose() {
            this.isParamVisible = false;
          },

          reportList() {
            this.checkExistFavorite('/app/reports/pharmacy');
            this.$router.push({ name: "reportListPharmacy" }).catch(()=>{});
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pDrugList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pPatientCodeList',paramValue: this.params.PatientCode })
            this.reportParams.push({ paramName: 'pDrugType', paramValue: this.params.DrugType})
            this.reportParams.push({ paramName: 'pStatus', paramValue: this.params.Status})
            this.reportParams.push({ paramName: 'pAutoValidateStatus', paramValue: this.params.AutoValidatedStatus})
            this.reportParams.push({ paramName: 'pAdmiType', paramValue: this.admiType})
            this.reportParams.push({ paramName: 'pOrder', paramValue: this.order})
            this.reportParams.push({ paramName: 'pSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
          },

          onClickShowReport() {
            this.isParamVisible = false
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportDetailPrescribedDrugDFilters.buildDocument(this.reportParams)
          },

          LoadDetailPrescribedDrugs() {
            if (!this.validateForm()) return;
            
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          initializeParameters() {
           
            // Asignaciones condicionales
            this.parameter.DrugList = this.params.DrugList && this.params.DrugList !== '' 
                ? this.params.DrugList 
                : null;
            
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
            this.parameter.DrugType = this.params.DrugType && this.params.DrugType !== '' 
              ? this.params.DrugType
              : null;
            this.parameter.PatientCodeList = this.params.PatientCode && this.params.PatientCode !== '' 
                ? this.params.PatientCode
                : null;
            this.parameter.Status = this.params.Status && this.params.Status !== '' 
                ? this.params.Status
                : null;
           
            this.parameter.AdmissionType = this.admiType;
            this.parameter.AutoValidatedStatus = this.params.AutoValidatedStatus && this.params.AutoValidatedStatus !== ''
                ? this.params.AutoValidatedStatus
                : null;
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_iss_WebDetailedPrescribedDrugwithDiagnosis'; 
            this.initializeParameters();

            const spParameters = {
                SearchCriteria: this.parameter.SearchCriteria,
                DrugCodeList: this.parameter.DrugList,
                DrugTypeList: this.parameter.DrugType,
                PatientCodeList: this.parameter.PatientCodeList,
                Status: this.parameter.Status,
                AutoValidatedStatus: this.parameter.AutoValidatedStatus,
                AdmissionType: this.parameter.AdmissionType,
                DateFrom: this.parameter.DateFrom,
                DateTo: this.parameter.DateTo,
            };
            
            const request = {
                procedureName: procedureName,
                parameters: spParameters,
                pageNumber: this.parameter.PageNumber,
                pageSize: this.parameter.PageSize
            };
          
            UtilsService.getExecuteSP(request)
              .then(response => {
                  if (response.status == "200" && response.data) {
                      this.items = response.data;
                      this.items.forEach(function(element) {
                        let { IssuedDate } = element
                        if (IssuedDate) element.IssuedDate = Utils.formatterDateToString(IssuedDate);            
                      });
                      let headerString = response.headers["x-pagination"];
                      this.Header = JSON.parse(headerString);
                      this.totalRows = this.Header.TotalCount;
                      this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                      this.$emit('showEmptyRecords', this.showEmptyRecords);
                  }
              })
              .catch(error => {
                  this.showResponseErrorMessage(error);
              });
          },

          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            if (!this.validateForm()) return;

            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            if (!this.validateForm()) return;

            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('DetailPrescribedDrugsD', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('DetailPrescribedDrugsD', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          validate_date_range() {
            return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
          },

          // Método de validación reutilizable
          validateForm() {
            const isValid = this.validate_date_range();
       
            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;
            
            // Forzar actualización del componente
            this.$forceUpdate();
            
            if (!isValid) {
              this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
              return false;
            }
            return true;
          },
      },
      created() {
       
      },

      mounted () {
        this.getDrugTypeFilter();

        PharmacyOptionService.getPharmacyOptions()
          .then(response => {
            if (response.status == '200' && response.data && response.data.length > 0) {
              this.validateInternalPrescriptions = response.data[0].validateInternalPrescriptions === true;
            }
          })
          .catch(() => {});

        EventBus.$on("ShowWeel", function (isShow) {
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
